import { api } from '@api' // Your existing API wrapper
import dayjs from 'dayjs' // Import dayjs
import utc from 'dayjs/plugin/utc' // Day.js UTC plugin
import { createEffect, createSignal } from 'solid-js'
import { userId } from './auth'

// Enable UTC plugin for dayjs
dayjs.extend(utc)
const intervalMs: number = 60000

export function useLastSeen() {
  const [lastSeen, setLastSeen] = createSignal<string | null>(null)

  const updateLastSeen = async () => {
    const updatedTime = dayjs.utc().toISOString() // Get current time in UTC
    const { error } = await api().from('last_seen').upsert(
      {
        profile_id: userId()!,
        updated_at: updatedTime,
      },
      { onConflict: 'profile_id' },
    )

    if (error) {
      console.error('Failed to update last_seen:', error.message)
    } else {
      setLastSeen(updatedTime)
    }
  }

  createEffect(() => {
    if (userId()) {
      // Start the heartbeat
      const interval = setInterval(() => {
        updateLastSeen()
      }, intervalMs)

      updateLastSeen()

      // Clean up on component unmount
      return () => clearInterval(interval)
    }
  })

  return {
    lastSeen,
    updateLastSeen,
  }
}
